import UpsizedCell from './UpsizedCell';

export default UpsizedCell;
